/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ShellComponent } from './shell.component';
import { HeaderComponent } from './header/header.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SharedModule } from '@app/shared';

@NgModule({
  imports: [CommonModule, TranslateModule, NgbModule, RouterModule, NgScrollbarModule, SharedModule],
  declarations: [HeaderComponent, ShellComponent, SideMenuComponent],
})
export class ShellModule {}
